import classnames from 'classnames';
import _get from 'lodash/get';
import _invert from 'lodash/invert';
import _isNumber from 'lodash/isNumber';
import _memoize from 'lodash/memoize';
import React from 'react';
import intl from 'react-intl-universal';
import { RouteComponentProps } from 'react-router-dom';
import { Tab } from 'semantic-ui-react';
import Icon from 'components/Common/Icon';
import { TabProps } from 'semantic-ui-react/dist/commonjs/modules/Tab/Tab';
import GroupContactsTab from '../../containers/Users/GroupContactsTabContainer';
import UsersTab from '../../containers/Users/UsersTabContainer';
import { ListViewLayoutHeader } from '../ListViewLayout/ListViewLayoutHeader';
import * as styles from './Users.scss';
 
const keyToActiveIndex = {
  '/users/users': 0,
  '/users/group': 1
};
 
const activeIndexToKey = _invert(keyToActiveIndex);
 
interface State {
  selectedTab: number;
}
 
class UsersComponent extends React.Component<RouteComponentProps<{}>, State> {
 
  readonly state: State = {
    selectedTab: (_get(this.props.match, 'params.tab', 'users') === 'users' ? 0 : 1)
  };
 
  /**
   * Updates header title based on selected tab
   * @param selectedTab
   */
  getTitle = _memoize((selectedTab: number) => {
    if (selectedTab === 0) {
      return (
        <>
          <Icon classes={['icon-contact-profile']} />
          <span>{intl.get('usersTab')}</span>
        </>
      );
    }
    return (
      <>
        <Icon classes={['icon-contact-profile']} />
        <span>{intl.get('contactsTab')}</span>
      </>
    );
  });
 
  panes = [
    {
      menuItem: (
        {
          key: 'usersTab',
          content: (<div data-test="userSubTab">{intl.get('usersTab')}</div>)
        }),
      render: () => (
        <Tab.Pane key={'0'} attached={false}>
          <UsersTab />
        </Tab.Pane>
      )
    },
    {
      menuItem: (
        {
          key: 'contactsTab',
          content: (
            <div data-test="groupContactsSubTab">{intl.get('contactsTab')}</div>
          )
        }
      ),
      render: () => (
        <Tab.Pane key={'1'} attached={false}>
          <GroupContactsTab />
        </Tab.Pane>
      )
    }
  ];
 
  getCurrentIndex() {
    const tab = this.props.history.location.pathname || '/users/users';
    return keyToActiveIndex[tab];
  }
 
  handleTabChange = (event: React.MouseEvent<HTMLDivElement>, tabData: TabProps) => {
    if (_isNumber(tabData.activeIndex) && this.state.selectedTab !== tabData.activeIndex) {
      this.setState({ selectedTab: tabData.activeIndex });
    }
    const activeIndex = tabData.activeIndex || 0;
    const url = activeIndexToKey[activeIndex];
    this.props.history.push(url);
  }
 
  render() {
    return (
      <div className={styles.container}>
        <ListViewLayoutHeader title={this.getTitle(this.state.selectedTab)} />
        <div className={classnames(styles.tabsContainer, 'tabset')}>
          <Tab
            activeIndex={this.getCurrentIndex()}
            menu={{ secondary: true, pointing: true }}
            onTabChange={this.handleTabChange}
            panes={this.panes}
          />
        </div>
      </div>
    );
  }
 
}
 
export default UsersComponent;
